import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { LabRoutingModule } from './lab-routing.module';
import { DemographicsComponent } from './demographics/demographics.component';
import { ChangeLogComponent } from './changeLogs/changeLog.component';
import { LicenseCashComponent } from './licenceCash/licenseCash.component';
import { ProficiencyComponent } from './proficiency/proficiency.component';
import { EditProficiencyResultComponent } from './proficiency/editProficiencyResult/editProficiencyResult.component';
import { AddLabProficiencyComponent } from './proficiency/addLabProficiency/addLabProficiency.component';
import { SpecialtyComponent } from './specialty/specialty.component';
import { AssociatedComponent } from './associated/associated.component';
import { ParentComponent } from './associated/parent/parent.component';
import { HstComponent } from './associated/HST/hst.component';
import { SoaComponent } from './associated/SOA/soa.component';
import { SharedAssociatedComponent } from './associated/sharedAssociated/sharedAssociated.component';
import { MultipleComponent } from './associated/multiple/multiple.component';
import { SurveyComponent } from './surveys/surveys.component';


const COMPONENTS = [
    DemographicsComponent,
    ProficiencyComponent,
    LicenseCashComponent,
    ChangeLogComponent,
    EditProficiencyResultComponent,
    AddLabProficiencyComponent,
    SpecialtyComponent,
    AssociatedComponent,
    ParentComponent,
    HstComponent,
    SoaComponent,
    SharedAssociatedComponent,
    MultipleComponent,
    SurveyComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    LabRoutingModule,
    SharedModule
  ],
  exports: [
    DemographicsComponent,
    ProficiencyComponent,
    LicenseCashComponent,
    ChangeLogComponent, 
    EditProficiencyResultComponent,
    AddLabProficiencyComponent,
    SpecialtyComponent,
    AssociatedComponent,
    ParentComponent,
    HstComponent,
    SoaComponent,
    SharedAssociatedComponent,
    MultipleComponent,
    SurveyComponent
  ]
})
export class LabModule { }